import { styled } from '@lichtblick/styled';
import { Spacing } from '@lichtblick/theme';

/**
 * Form.Root — outermost container that establishes a CSS container context.
 * All child `Form.Row` / `Form.Field` components respond to this container's width.
 */
export const Root = styled.div`
  container-type: inline-size;
  display: flex;
  flex-direction: column;
  gap: var(--form-root-gap, ${Spacing.Xs});
  width: 100%;
`;

/**
 * Form.Row — a responsive row that auto-flows fields between 1↔2 columns.
 * At narrow container widths (≤500px) fields stack into a single column.
 */
export const Row = styled.div`
  display: grid;
  gap: var(--form-row-gap, ${Spacing.Xs});
  grid-template-columns: repeat(auto-fit, minmax(var(--form-field-min-width, 12rem), 1fr));
  width: 100%;

  @container (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

/**
 * Form.Field — a single field slot within a row.
 * Defaults to occupying one grid cell; `$span="full"` forces full-width.
 */
export const Field = styled.div<{ $span?: 'full' | 'half' }>`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['3Xs']};
  min-width: 0;

  ${({ $span }) => $span === 'full' && 'grid-column: 1 / -1;'}
`;
